'use strict';

/* eslint global-require: 0 */
module.exports = require('./ReactSixteenAdapter');


//////////////////
// WEBPACK FOOTER
// ./node_modules/enzyme-adapter-react-16/build/index.js
// module id = 1275
// module chunks = 0